var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhdollarCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4102 58.5137C35.4102 63.7812 39.4527 68.0279 44.4752 68.0279H54.7243C59.0935 68.0279 62.646 64.312 62.646 59.7387C62.646 54.757 60.4818 53.0012 57.256 51.8579L40.8002 46.1412C37.5743 44.9979 35.4102 43.242 35.4102 38.2604C35.4102 33.687 38.9627 29.9712 43.3318 29.9712H53.581C58.6035 29.9712 62.646 34.2179 62.646 39.4854",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49 24.5V73.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49 89.8332C71.5517 89.8332 89.8334 71.5515 89.8334 48.9998C89.8334 26.4482 71.5517 8.1665 49 8.1665C26.4484 8.1665 8.16669 26.4482 8.16669 48.9998C8.16669 71.5515 26.4484 89.8332 49 89.8332Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhdollarCircle);
export default __webpack_public_path__ + "static/media/whdollar-circle.1f4cb259039f7a864bcbede671cb5fc2.svg";
export { ForwardRef as ReactComponent };